import * as React from "react";
import PropTypes from 'prop-types';

const SvgRecycle = props => {
  if (props.id !== "_svgrecycle") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M27.424 18.876l1.164.325-2.902-5.026a1.468 1.468 0 00-1.268-.733c-.521 0-1.007.28-1.268.732l-3.697 6.404a.721.721 0 11-1.249-.722l3.697-6.403A2.914 2.914 0 0124.418 12c1.035 0 2 .557 2.517 1.453l2.892 5.01.313-1.116a.722.722 0 011.389.389l-.788 2.816a.721.721 0 01-.889.5l-2.816-.787a.721.721 0 01.388-1.39zm9.078 11.174c.517.897.516 2.01-.001 2.907a2.915 2.915 0 01-2.517 1.452h-.001l-5.785-.003.81.829a.721.721 0 11-1.032 1.008l-2.044-2.092a.72.72 0 01.012-1.02l2.091-2.044a.72.72 0 111.008 1.032l-.864.844 5.804.003h.001a1.47 1.47 0 001.268-.73 1.47 1.47 0 000-1.465l-3.693-6.405a.721.721 0 011.25-.72zm-14.204 3.03a.721.721 0 010 1.442h-.001l-7.394-.005a2.915 2.915 0 01-2.516-1.455 2.915 2.915 0 01.002-2.906l2.896-5.008-1.123.287a.722.722 0 01-.357-1.398l2.834-.724a.72.72 0 01.877.52l.724 2.834a.721.721 0 01-1.398.357l-.299-1.171-2.905 5.025a1.468 1.468 0 00-.001 1.464c.26.452.746.733 1.267.733z" fill="#333" fillRule="evenodd" /></svg>;
};

SvgRecycle.displayName = "_svgrecycle";
SvgRecycle.propTypes = {
  id: PropTypes.string
};
SvgRecycle.defaultProps = {
  id: ''
};
export default SvgRecycle;